export default class Agendamento {

  constructor (
    id = 0,
    nome = '',
    possuiDiasPendentes = false,
    lotacao = '',
    ano = 0,
    dataInicioFerias = null,
    statusAprovacao = 'PENDENTE',
    idFuncionarioResponsavel = null,
    idFuncionarioResponsavelSegundo = null
  ) {
    this.id = id;
    this.nome = nome;
    this.possuiDiasPendentes = possuiDiasPendentes;
    this.lotacao = lotacao;
    this.ano = ano;
    this.dataInicioFerias = dataInicioFerias;
    this.statusAprovacao = statusAprovacao;
    this.idFuncionarioResponsavel = idFuncionarioResponsavel;
    this.idFuncionarioResponsavelSegundo = idFuncionarioResponsavelSegundo;
  }
}



// WEBPACK FOOTER //
// ./src/domain/ferias/agendamento.js